import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineMessageComponent, InlineMessageContent } from './inline-message.component';
import { IconModule } from '@liberty-financial/ng-components';



@NgModule({
  declarations: [InlineMessageComponent, InlineMessageContent],
  imports: [CommonModule, IconModule],
  exports: [InlineMessageComponent, InlineMessageContent]
})
export class DynamicInlineMessageModule { }
